import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/homepage/hero";
import Testimonials from "../components/universal/testimonials";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";
import Services from "../components/services/Services";
import Consult from "../components/universal/consult";
import Invisalign from "../components/homepage/invisalign";
import Chooseus from "../components/homepage/chooseus";
import StarterCard from "../components/universal/starterCard";
import Story from "../components/homepage/story";
import Review from "../components/universal/review";
import Team from "../components/universal/team";
import Gallery from "../components/universal/gallery";
import Question from "../components/universal/Question";
import Price from "../components/universal/price";
import Expect from "../components/homepage/expect";
import Offer from "../components/homepage/special-offer";
import { useRef } from "react";
import FloatingContactButton from "../components/universal/FloatingContactButton";

function Index() {
  const consultRef = useRef(null);

  const scrollToConsult = () => {
    consultRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div>
      <FloatingContactButton scrollToConsult={scrollToConsult} />
      <Helmet>
        <title>Composite Bonding Ilkley | Smile Makeovers by Experts</title>
        <link rel="canonical" href="https://www.compositebonding-ilkley.com/" />
        <meta
          name="description"
          content="Transform your smile with composite bonding at Regent Dental, serving Ilkley and Keighley—expertly crafted by Dr Naeem Ashfaq to boost your natural beauty and confidence."
        />
      </Helmet>
      <Navbar scrollToConsult={scrollToConsult} />
      <Header scrollToConsult={scrollToConsult} />
      <Services />
      <div ref={consultRef}>
        <Consult />
      </div>
      <Invisalign />
      <Expect scrollToConsult={scrollToConsult} />
      <Chooseus scrollToConsult={scrollToConsult} />
      <StarterCard scrollToConsult={scrollToConsult} />
      {/* <Story /> */}
      <Review scrollToConsult={scrollToConsult} />
      <Gallery />
      <Offer scrollToConsult={scrollToConsult} />
      <Price scrollToConsult={scrollToConsult} />
      <Team />
      <Question />
      <Contact scrollToConsult={scrollToConsult} />
      <Footer />
    </div>
  );
}

export default Index;
